import { useEvent } from "@/app/hooks/use-event"
import { CloseIcon } from "@/app/icons/close"
import type { NftId } from "@anaconda/core/nft/types"
import { Trans } from "@lingui/react/macro"
import { Button, cn } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftsToBuyMoleculeReatom } from "./molecule.reatom"

interface Props {
  nftId: NftId
  className?: string
}

export const RemoveNftSelection = reatomComponent<Props>(
  ({ nftId, className }) => {
    const { removeNft } = useMolecule(NftsToBuyMoleculeReatom)

    const onClick = useEvent(() => removeNft(nftId))

    return (
      <Button
        variant="ghost"
        type="button"
        onClick={onClick}
        className={cn("px-1", className)}
      >
        <div className="flex items-center gap-2">
          <CloseIcon className="[&&]:h-3 [&&]:w-3" />
          <Trans>Remove</Trans>
        </div>
      </Button>
    )
  },
  "RemoveNftSelection",
)
